/* eslint-disable camelcase */
import { SET_POLLING_ID } from 'reducers/actions-types';
import { poll as pollURL } from 'constants/api-urls';
import deliveryActions from 'reducers/modules/delivery/actions';
import checkoutActions from 'reducers/modules/checkout/actions';
import ruit from 'ruit';
import notificationsActions from 'reducers/modules/notifications/actions';
import cartActions from 'reducers/modules/cart/actions';
import axios from 'axios';
import getOrderState from 'util/misc/get-order-state';

/**
 * The poll interval default which can be overriden from consumers
 */
export const INTERVAL = 15000; // 15 seconds
export const INTERVAL_FAST = 500; // 500ms


/**
 * The current timer, if the poll is running
 */
let timer;

/**
 * Handle the polling errors avoiding showing errors
 * @returns {Promise<boolean>}
 */
function onError({ dispatch, getState }, fast) {
    poll({ dispatch, getState }, fast);
    return Promise.resolve(false);
}

/**
 * Success handler triggered after any polling request
 * @returns {Promise<boolean>}
 */
function onSuccess({ dispatch, getState, data }, fast) {
    const { state } = data;
    const resolve = () => Promise.resolve(true);
    const { isActive } = getOrderState(state);

    dispatch(deliveryActions.setStatus({ status: state }));

    if (isActive) {
        poll({ dispatch, getState, fast }); // Recursively invoke the timer
        return resolve();
    }

    dispatch(checkoutActions.reset());
    dispatch(cartActions.reset());

    // get a new order
    return dispatch(actions.requestOrder());
}

/**
 * Ticker function for the polling iterations
 * @returns {Promise<boolean>}
 */
function onTick({ getState, dispatch }, fast) {
    const handleError = () => onError({ dispatch, getState }, fast);
    const state = getState();
    const cartId = state.cart.id;
    const isLogged = state.user.isAuthenticated;

    dispatch({ type: SET_POLLING_ID, id: cartId });

    if (!cartId || !isLogged) {
        return Promise.resolve(handleError());
    }

    return axios
        .get(pollURL(cartId))
        .then(({ data }) => onSuccess({ dispatch, getState, data, fast }))
        .catch(handleError);
}

/**
 * Get the current poll update from the server
 * @returns {Promise}
 */
function poll({ dispatch, getState, isInitial }, fast = false) {
    // clear any previous pending polling request
    clear();

    return new Promise(resolve => {
        const tick = () => resolve(onTick({ dispatch, getState }, fast));

        if (isInitial) {
            tick();
        } else {
            requestAnimationFrame(() => {
                timer = setTimeout(tick, fast ? INTERVAL_FAST : INTERVAL);
            });
        }
    });
}

/**
 * Clear the current timeout
 */
function clear() {
    clearTimeout(timer);
    timer = null;
}

const actions = Object.freeze({
    startPollFast() {
        return (dispatch, getState) => {
            return poll({ dispatch, getState, isInitial: true }, true);
        };
    },
    startPoll() {
        return (dispatch, getState) => {
            return poll({ dispatch, getState, isInitial: true }, false);
        };
    },
    requestOrder() {
        return (dispatch, getState) => {
            const startPolling = () => poll({ dispatch, getState, isInitial: true }, false);

            return ruit(
                () => dispatch(cartActions.fetchCart()),
                () => dispatch(notificationsActions.fetch()),
                () => startPolling(),
            ).catch(startPolling);
        };
    },
    stopPoll() {
        return (dispatch) => {
            clear(dispatch);
        };
    },
});

export default actions;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/poll/actions.js